import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import economyReducers from "../reducers"

// Spend credits on a class. The response carries the new balance and the whole catalogue, so the
// card flips to "owned" and the balance drops from one answer — nothing has to be re-fetched, and
// there is no moment where the two disagree.
export const thunk = createAsyncThunk("economy/buyRace", async ({ race }, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/shop/races/", { race })
    return {
      credits: response.data.credits,
      races: response.data.races,
      // The lobby reads `unlockedRaces`, not the catalogue, so it has to move too or the class
      // stays locked on the screen the player bought it for.
      unlockedRaces: response.data.races.filter((entry) => entry.owned).map((entry) => entry.race),
    }
  } catch (error) {
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = economyReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
